import { useTransitionStyles } from '@floating-ui/react';
export var getClosedStyles = function (_a) {
    var side = _a.side;
    if (side === 'top') {
        return { opacity: 0, transform: 'translateY(-8px)' };
    }
    if (side === 'bottom') {
        return { opacity: 0, transform: 'translateY(8px)' };
    }
    if (side === 'left') {
        return { opacity: 0, transform: 'translateX(-8px)' };
    }
    if (side === 'right') {
        return { opacity: 0, transform: 'translateX(8px)' };
    }
    return {};
};
var getOpenedStyles = function (_a) {
    var side = _a.side;
    if (side === 'top' || side === 'bottom') {
        return { opacity: 1, transform: 'translateY(0px)' };
    }
    if (side === 'left' || side === 'right') {
        return { opacity: 1, transform: 'translateX(0px)' };
    }
    return {};
};
export function usePopoverTransition(context) {
    return useTransitionStyles(context, {
        duration: { open: 200, close: 130 },
        close: getClosedStyles,
        open: getOpenedStyles,
    });
}
//# sourceMappingURL=usePopoverTransition.js.map